import React, { useState, useEffect } from "react";
import "../components/Loading.css";
import "./ComingSoon.css";
import { CONTACT_EMAIL, INSTAGRAM_URL, APP_LOGO_FULL, APP_LOGO_ALT } from "../config/site";

function ComingSoon() {
  const [loading, setLoading] = useState(true);
  const [doorOpen, setDoorOpen] = useState(false);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Start door opening animation
    const doorTimer = setTimeout(() => {
      setDoorOpen(true);
    }, 500);

    // Show content after door opens
    const contentTimer = setTimeout(() => {
      setShowContent(true);
      setLoading(false);
    }, 2500);

    return () => {
      clearTimeout(doorTimer);
      clearTimeout(contentTimer);
    };
  }, []);

  return (
    <div className="coming-soon-page">
      {/* Loading Animation Section */}
      <div className={`loading-section ${loading ? "active" : "fade-out"}`}>
        <div
          className="loading-background"
          style={{
            backgroundImage: `url(${APP_LOGO_FULL})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="loading-overlay"></div>
        </div>

        <div className="loading-content">
          <div className="door-container">
            {/* Left Door Half */}
            <div className={`door-door door-left ${doorOpen ? "open" : ""}`}>
              <div className="door-image-wrapper">
                <img
                  src="/door.jpeg"
                  alt="Door Left"
                  className="door-image door-left-img"
                />
              </div>
            </div>

            {/* Center Card Image - Only show one card */}
            {doorOpen && (
              <div className="door-card visible">
                <img
                  src="/card.jpeg"
                  alt="Rencin Gifting"
                  className="card-image"
                />
              </div>
            )}

            {/* Right Door Half */}
            <div className={`door-door door-right ${doorOpen ? "open" : ""}`}>
              <div className="door-image-wrapper">
                <img
                  src="/door.jpeg"
                  alt="Door Right"
                  className="door-image door-right-img"
                />
              </div>
            </div>
          </div>

          <div className="loading-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
        </div>
      </div>

      {/* Coming Soon Content */}
      <div className={`coming-soon-content ${showContent ? "visible" : ""}`}>
        {/* Background Image */}
        <div className="coming-soon-background">
          {/* <img src="/coming-soon.jpeg" alt="Coming Soon" className="coming-soon-bg-image" /> */}
          <img
            src="/box/colors/brown.png"
            alt="Coming Soon"
            className="coming-soon-bg-image"
          />
        </div>

        <div className="coming-soon-container">
          {/* Logo centered above Title */}
          <div className="title-logo-wrapper">
            <div className="coming-soon-logo">
              <img src={APP_LOGO_FULL} alt={APP_LOGO_ALT} />
            </div>

            <h1 className="coming-soon-title">
              <span className="title-line">Rencin Gifting</span>
              <span className="title-tagline">Unbox Every Occasion</span>
            </h1>
            {/* New Coming Soon Text */}
            <div className="coming-soon-text">Coming Soon</div>
          </div>
          {/* Subtitle */}
          <p className="coming-soon-subtitle">
            We're crafting something extraordinary for you
          </p>

          {/* Description */}
          <div className="coming-soon-description">
            <p>
              From festive hampers to premium personalised gift boxes, we're
              preparing a collection that celebrates timeless elegance and
              modern sophistication.
            </p>
          </div>

          {/* Social Links */}
          <div className="social-links">
            <p className="social-text">Connect with us</p>
            <div className="social-icons">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="social-icon"
                aria-label="Email"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                  <path
                    d="M22 6L12 13L2 6"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </svg>
              </a>
              <a
                href={INSTAGRAM_URL}
                className="social-icon"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="2"
                    y="2"
                    width="20"
                    height="20"
                    rx="5"
                    ry="5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                  />
                  <path
                    d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                  />
                  <line
                    x1="17.5"
                    y1="6.5"
                    x2="17.51"
                    y2="6.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/share/1GeTpW5duq/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
                aria-label="Facebook"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17V10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                  />
                </svg>
              </a>
            </div>
          </div>

          {/* Footer */}
          <div className="coming-soon-footer">
            <p>
              © {new Date().getFullYear()} Rencin Gifting. All rights reserved.
            </p>
            <p className="footer-location">📍 Mumbai, India</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
